export default {
  "index": {
    "theWordCountShallNotExceed": "The word count must not exceed {val1} characters"
  }
}